import React from "react";
import { ProfileImg } from "./profileImg";
import ArrowRight from "../../../images/icons/arrow-right.inline.svg";
import { Link } from "../../../utils/customLink";

export const OpenDaySlide = ({
  meetupStaffMembers,
  meetUpTitle,
  meetUpLocation,
  meetupDate,
  meetupDateTime,
  meetupDescription,
  meetupDetailUri
}) => {
  const layoutStructure = [
    {
      wrapperClass: "row-span-3",
      namePosition: "right",
      imgSize: "big"
    },
    {
      wrapperClass: "row-span-1",
      namePosition: "left",
      imgSize: "small"
    },
    {
      wrapperClass: "row-span-3",
      namePosition: "left",
      imgSize: "big"
    },
    {
      wrapperClass: "row-span-1",
      namePosition: "right",
      imgSize: "small"
    }
  ];

  return (
    <div className="flex flex-col-reverse w-11/12 py-8 mx-auto md:w-7/12 md:flex-row md:py-16">
      <div className="w-full md:w-5/12 pt-9 md:pt-0">
        <div className="grid grid-cols-2 gap-[3px] rtl-grid md:ltr-grid">
          <div className="hidden h-5 row-span-1 md:block" />
          {meetupStaffMembers &&
            meetupStaffMembers.map((data, index) => {
              const { title, featuredImage, teamMembersFields } = data ?? {};

              const memberName = title ?? "";
              const memberImage =
                featuredImage?.node?.localFile &&
                featuredImage?.node?.localFile.publicURL
                  ? featuredImage?.node?.localFile?.publicURL
                  : featuredImage?.node?.sourceUrl;
              const memberRole = teamMembersFields?.teamPosition ?? "";

              return (
                <ProfileImg
                  imgSize={layoutStructure[index]?.imgSize}
                  namePosition={layoutStructure[index]?.namePosition}
                  wrapperClass={layoutStructure[index]?.wrapperClass}
                  key={index}
                  memberTitle={memberName}
                  imgSrc={memberImage}
                  memberRole={memberRole}
                />
              );
            })}
        </div>
      </div>
      <div className="relative flex flex-col items-center w-full md:items-end md:w-7/12 md:pl-6">
        <div className="p-10 pb-24 border border-white gvi-blur-bg-second md:pb-10">
          <h1 className="font-normal planet:!font-bold !text-white">
            {meetUpTitle}
          </h1>
          <h3 className="!font-normal !text-white">
            {meetUpLocation &&
              meetupDateTime &&
              [meetUpLocation, meetupDateTime?.split("at ")[0]]?.join(" : ")}

            {meetUpLocation && !meetupDateTime && meetUpLocation}
            {meetupDateTime?.split("at ")[0] &&
              !meetUpLocation &&
              meetupDateTime?.split("at ")[0]}

            <br />
            {meetupDateTime?.split(", ")?.slice(1)?.join(", ")
              ? meetupDateTime?.split(", ")?.slice(1)?.join(", ")
              : meetupDateTime?.split("at ")[1]}
          </h3>
          <h6
            className="!font-normal pt-3 !text-white"
            dangerouslySetInnerHTML={{ __html: meetupDescription }}
          />
        </div>
        <Link
          to={meetupDetailUri}
          className="absolute flex items-center justify-center w-3/4 px-5 py-2 mt-3 ml-auto border border-white rounded-full cursor-pointer md:w-auto md:static bottom-8 planet:rounded-sm"
        >
          <p className="pr-2 text-base font-bold text-white">Join Open Day</p>
          <ArrowRight className="w-3 h-3 ml-1 stroke-white" />
        </Link>
      </div>
    </div>
  );
};
